import { Cari } from './cari';
import { Talep } from './talep';
import { TeklifKalem } from './teklif-kalem';
import { Master } from './master';
import { TeklifFiyatDegisiklik } from './teklif-fiyat-degisiklik';
import { TeklifGorsel } from './teklif-gorsel';

export class Teklif {

  public static DURUM_INITIAL = 0;
  public static DURUM_CEVAPLANDI = 1;
  public static DURUM_RED = 2;
  public static DURUM_IPTAL = 3;
  public static DURUM_REVIZE_EDILDI = 4;
  public static DURUM_DEGERLENDIRILDI = 5;


  id: number;
  durum: number;
  cari: Cari;
  mailGonder: boolean;
  talep: Talep;
  teslimYeriId: number;
  teslimSekliId: number;
  odemeYontemiId: number;
  teslimTarihi: Date = null;
  opsiyon: string;
  garantiSuresi: string;
  firmaTeklifNotu: string;
  private olusturmaTarihi: string;
  talepId: number;
  private pTeklifKalemler: TeklifKalem[];
  teslimSekli: Master;
  odemeYontemi: Master;
  teslimSuresi: number;
  teklifFiyatDegisiklikler: TeklifFiyatDegisiklik[];
  teslimYeri: Master;
  isGorselGoster: boolean;
  private pTeklifGorseller: TeklifGorsel[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.cari != null) {
      this.cari = new Cari(obj.cari);
    }
    if (obj.talep != null) {
      this.talep = new Talep(obj.talep);
    }
    if (obj.teslimSekli != null) {
      this.teslimSekli = new Master(obj.teslimSekli);
    }
    if (obj.odemeYontemi != null) {
      this.odemeYontemi = new Master(obj.odemeYontemi);
    }
  }

  public get teklifGorseller(): TeklifGorsel[] {
    return this.pTeklifGorseller;
  }

  public set teklifGorseller(list: TeklifGorsel[]) {
    if (list != null) {
      this.pTeklifGorseller = list.map(t => new TeklifGorsel(t));
    }
  }
  get durumText(): string {
    if (this.durum != null) {
      return Teklif.getDurumText(this.durum, this.mailGonder);
    }
    return '';
  }

  public static getDurumText(durum: number, mailGonder: boolean): string {
    if (durum != null) {
      switch (durum) {
        case Teklif.DURUM_INITIAL:
          if (mailGonder)
            return 'Talep Gönderildi';
          else
            return '';
        case Teklif.DURUM_IPTAL:
          return 'İptal Edildi';
        case Teklif.DURUM_RED:
          return 'Red Edildi';
        case Teklif.DURUM_CEVAPLANDI:
          return 'Teklif Verildi';
        case Teklif.DURUM_REVIZE_EDILDI:
          return 'Revize Edildi';
        case Teklif.DURUM_DEGERLENDIRILDI:
          return 'Değerlendirildi';
      }
    }
    return '';
  }

  get olusturmaTarihiText(): string {
    if (this.olusturmaTarihi != null) {
      const date = new Date(this.olusturmaTarihi);
      return date.toLocaleString();
    }
    return '';
  }

  get teslimTarihiText(): string {
    if (this.teslimTarihi != null) {
      const date = new Date(this.teslimTarihi);
      return date.toLocaleString();
    }
    return '';
  }

  public get teklifKalemler(): TeklifKalem[] {
    return this.pTeklifKalemler;
  }

  public set teklifKalemler(list: TeklifKalem[]) {
    if (list != null) {
      this.pTeklifKalemler = list.map(t => new TeklifKalem(t));
    }
  }
}
